import { Component, OnInit } from '@angular/core';
import { UpdatePasswordComponent, UpdatePasswordComponentService } from '@spartacus/user/profile/components';
import { SpinnerComponent, FormErrorsComponent } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, UrlPipe } from '@spartacus/core';

enum ICON_TYPE {
  INFOCIRCLEFILLED= 'INFOCIRCLEFILLED',
}

@Component({
    selector: 'app-efa-update-password',
    templateUrl: './efa-update-password.component.html',
    imports: [SpinnerComponent, FormsModule, ReactiveFormsModule, FormErrorsComponent, RouterLink, AsyncPipe, TranslatePipe, UrlPipe]
})

export class EfaUpdatePasswordComponent extends UpdatePasswordComponent implements OnInit {

  readonly iconTypes = ICON_TYPE;
  constructor(protected service: UpdatePasswordComponentService) {
    super(service);
  }

  ngOnInit(): void {
  }

}
